import { useCallback } from "react";
import useDeletePathPickBasket from "@/features/pathpick/features/basket/hooks/mutation/useDeletePathPickBasket";
import usePathPickBasketSelection from "@/features/pathpick/features/basket/hooks/usePathPickBasketSelection";
import { PathPickMutationProduct } from "@/features/pathpick/types";

// 담은 상품 삭제 — 서버 삭제 성공 시 선택 상태에서도 함께 제거한다.
// 헤더(선택 삭제)와 카드 리스트(개별 삭제) 양쪽에서 쓰이므로 훅으로 공유한다.
//
// removeProducts는 formik setFieldValue 기반이라 identity가 고정이므로 반환 함수도 렌더 간 고정된다
// — 카드(React.memo) 경계가 유지되려면 이게 전제조건이다.
const useRemovePathPickBasketItems = () => {
  const { mutate: deleteBasket } = useDeletePathPickBasket();
  const { removeProducts } = usePathPickBasketSelection();

  // 상품 조회(isInBasket) 기반이라 항목 id가 곧 productId다.
  return useCallback(
    (products: PathPickMutationProduct[]) => {
      if (products.length === 0) {
        return;
      }
      deleteBasket({ products }, { onSuccess: () => removeProducts(products) });
    },
    [deleteBasket, removeProducts]
  );
};

export default useRemovePathPickBasketItems;
